import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginVisible: false,
    surveyVisible: false,
    userInfo: null,
    layoutSearchMsg:''
  },
  mutations: {
    updateLoginVisible(state, isShow) {
      state.loginVisible = isShow
    },
    updateSurveyVisible(state, isShow) {
      state.surveyVisible = isShow
    },
    updateUserInfo(state, user) {
      state.userInfo = user
    },
    updateLayouSearMsg(state, msg) {
      state.layoutSearchMsg = msg
    },
  },
  actions: {},
  modules: {},
})
